/**
 * Move price element on product page.
 */
(function($) {

    var priceContainer, initPrice, prevPrice;

    priceContainer = $('.single-product .product-type-variable .price')
        .not('.single-product .product-type-variable .related .price, .single-product .product-type-variable .upsells .price');

    initPrice = prevPrice = priceContainer.html();

    // Default price hiding function
    function hideDefaultPrice() {
        // Default Price hiding condition
        $('.product-type-variable .single_variation_wrap .woocommerce-variation-price').hide();
    }

	// Function to run- on changing the variation dropdown
	function changePrice(variationPrice) {
		if (prevPrice === variationPrice) {
			return;
		}

		priceContainer.animate({ opacity: 0 }, 200, function() {
			window.setTimeout(function() {
				priceContainer.html(variationPrice).animate({ opacity: 100 }, 200);
				prevPrice = variationPrice;
			}, 100);
		});
	}

    // Triggering the `show_variation` event
    $(".single_variation_wrap").on("show_variation", function (event, variation) {
        // Getting variation price
        var variationPrice = $(variation.price_html).html();
        // Passing variation price to the function
        changePrice(variationPrice);
        hideDefaultPrice();

    });

    // Triggering `hide_variation` event
    $(".single_variation_wrap").on("hide_variation", function (event) {
        changePrice(initPrice);
    });
})(jQuery);

/**
 * Toggle all relevant attributes when switching between variations.
 */
const observer = new window.MutationObserver(mutations => {
	mutations.forEach(mutation => {
		mutation.addedNodes.forEach(node => {
			toggleProductData(node);
		});
	});
});

const toggleProductData = node => {
	if (!node.parentElement || !node.parentElement.classList.contains('sku')) {
		return;
	}
	toggleProductDataBySku(node.nodeValue);
}

const toggleProductDataBySku = sku => {
	document.querySelectorAll('[data-variation-ids]').forEach(element => {
		element.style.display = 'none';
		const variationIds = element.getAttribute('data-variation-ids').split(',');
		if (variationIds.includes(sku)) {
			element.style.display = 'inline';
		}
	});
}

const target = document.querySelector('.sku_wrapper');

if (target) {
	toggleProductDataBySku(target.querySelector('.sku').textContent);
	observer.observe(target, {
		childList: true,
		subtree: true,
		attributes: false,
		characterData: false,
	});
}

/**
 * Variation Table View - scrolling to table
 */
var yOffset = 0;

const updateScrollOffset = () => {
	const stickyHeader = document.querySelector('.suki-header-main-bar-inner');
	// Sticky header is hidden for mobile devices.
	if (stickyHeader) {
		const stickyHeaderSizePosition = stickyHeader.getBoundingClientRect();
		yOffset = stickyHeaderSizePosition.height + 20;
	}
};

['load', 'resize'].forEach(event => {
	window.addEventListener(event, updateScrollOffset);
});

document.querySelectorAll('.scroll-to-variation-table-view').forEach(element => {
	element.addEventListener('click', () => {
		const variationTable = document.querySelector('table.variation-table-view');
		if (variationTable) {
			const topOffset = variationTable.getBoundingClientRect().top + window.pageYOffset - yOffset;
			window.scrollTo({top: topOffset, behavior: 'smooth'});
		}
	});
});

/**
 * Variation Table View - compatibility with WooCommerce Back In Stock Notifications plugin
 */
var variationId = document.querySelector('input[name="variation_id"]');

const refreshForm = () => {
	document.querySelector('.variations select').dispatchEvent(new Event('change', { bubbles: true }));
};

// Workaround that forces to display the notification form when variation set in URL but not all attribute terms are given and it's not on the list.
window.addEventListener('load', () => {
	if (window.location.href.indexOf('attribute_pa_') === -1) {
		return;
	}
	if (parseInt(variationId.value, 10) > 0) {
		return;
	}
	setTimeout(refreshForm, 250);
});

const scrollToProduct = () => {
	const topOffset = document.querySelector('.product_title').getBoundingClientRect().top + window.pageYOffset - yOffset;
	window.scrollTo({top: topOffset, behavior: 'smooth'});
};

document.querySelectorAll('.variation-table-view .notify-me').forEach(element => {
	element.addEventListener('click', (event) => {
		const container = event.target.closest('tr');
		const variationAttributes = JSON.parse(decodeURIComponent(container.dataset.variationAttributes));
		Object.entries(variationAttributes).forEach((entry) => {
			let [index, value] = entry;
			const attributeSelect = document.getElementById(index);
			// Workaround that creates a temporary option when an attribute term is missing.
			// The notification form requires all attribute terms to be filled out.
			if (value === '') {
				value = '-';
			}
			// Create an option if it doesn't exist yet.
			if (![...attributeSelect.options].map(o => o.value).includes(value)) {
				attributeSelect.add(new Option(value, value));
			}
			attributeSelect.value = value;
		});
		variationId.value = container.dataset.variationId;
		// Don't refresh the form (trigger a change event) when the notification form is visible, otherwise it will dissapear.
		if (!jQuery('#wc_bis_product_form').is(':visible')) {
			refreshForm(); // Enable notification form.
		}
		const notificationRegistered = document.querySelector('#wc_bis_already_registered');
		if (notificationRegistered) {
			scrollToProduct();
			return;
		}
		const notificationForm = document.getElementById('wc_bis_product_form');
		if (!notificationForm) {
			return;
		}
		const notificationEmail = document.querySelector('#wc_bis_email'); // Indicates whether a user is logged in or not.
		// A guest user.
		if (notificationEmail) {
			scrollToProduct();
			notificationEmail.focus({
				preventScroll: true
			});
			return;
		}
		const notificationSendButton = document.querySelector('#wc_bis_send_form');
		// A logged in user.
		if (notificationSendButton) {
			notificationSendButton.click();
		}
	});
});

/**
 * Auto select variation if it is the only one available
 */
jQuery(document).on('change', '.variations select', function (event) {
	const options = [];
	let autoSelect = true;
	document.querySelectorAll('.variations select').forEach((element) => {
		if (event.target.id === element.id){
			return;
		}
		if (element.querySelectorAll('option.enabled').length !== 1) {
			autoSelect = false;
			return;
		}
		options.push(element);
	});
	if (!autoSelect) {
		return;
	}
	options.forEach((option) => {
		if (option.selectedIndex !== 0) {
			return;
		}
		jQuery(option).next().find('li.variable-item').not('.disabled').click();
	});
});

/**
 * Shipping Cost on Product Page plugin
 */
jQuery(($) => {
	const isSingleProduct = document.querySelector('body.single-product');

	if (!isSingleProduct) {
		return;
	}

	const isVariableProduct = document.querySelector('body.single-product div.product-type-variable');
	const calculatorShippingContainer = document.querySelector('.js--scpp-shipping-calculator-container');
	const calculateButton = document.querySelector('.js--scpp-calculate-button');
	const calculatorOpenButton = document.querySelector('.js--scpp-calculator-open-button')
	const postalCode = document.querySelector('#calc_shipping_postcode');
	const selectVariationText = document.querySelector('.select-variation-text');

	if (!calculatorOpenButton) {
		return;
	}

	// Show a postal code input field on load.
	if (!isVariableProduct) {
		calculatorOpenButton.click();
	}

	// Add ability to calculate shipping cost after clicking enter in the postal code input field.
	postalCode.addEventListener('keydown', (event) => {
		if (event.key !== 'Enter') {
			return;
		}
		calculateButton.click();
	});

	// On select variation event.
	$('form.variations_form').on('show_variation', (event, data) => { // console.log(data.variation_id);
		if (!calculateButton) {
			return;
		}
		calculatorShippingContainer.style.display = 'block';
		selectVariationText.style.display = 'none';
		if (postalCode.value) {
			calculateButton.click();
			return;
		}
		calculatorOpenButton.click();
	});

	// On unselect variation event.
	$('form.variations_form').on('hide_variation', () => { // console.log('variation hidden')
		calculatorShippingContainer.classList.add('viewed'); // Disable auto-calculation for variable products.
		calculatorShippingContainer.style.display = 'none';
		selectVariationText.style.display = 'block';
		calculatorOpenButton.style.pointerEvents = 'none';
	});
});
